import Vue from 'vue'
import store from './store'
import router from './router'
import Router from 'vue-router'
import App from './components/App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Video from 'video.js'
import 'video.js/dist/video-js.css';
import "@/assets/iconfont/font.css";

Vue.prototype.$video = Video //引入Video播放器

Vue.use(ElementUI)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {

  return originalPush.call(this, location).catch(err => err)
}
new Vue({
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js